/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown>, low: NonNullable<unknown>, high: NonNullable<unknown> }} Body_Assessment_Bodyfat_ValueInputs */

const en_us2_body_assessment_bodyfat_value = /** @type {(inputs: Body_Assessment_Bodyfat_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`about ${i?.percent}% (range ${i?.low}–${i?.high}%)`)
};

const pt_br2_body_assessment_bodyfat_value = /** @type {(inputs: Body_Assessment_Bodyfat_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`cerca de ${i?.percent}% (faixa de ${i?.low}% a ${i?.high}%)`)
};

const es_419_body_assessment_bodyfat_value = /** @type {(inputs: Body_Assessment_Bodyfat_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`alrededor de ${i?.percent}% (rango ${i?.low}–${i?.high}%)`)
};

const pt_pt2_body_assessment_bodyfat_value = /** @type {(inputs: Body_Assessment_Bodyfat_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`cerca de ${i?.percent}% (intervalo de ${i?.low}% a ${i?.high}%)`)
};

const fr_fr2_body_assessment_bodyfat_value = /** @type {(inputs: Body_Assessment_Bodyfat_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`environ ${i?.percent} % (fourchette ${i?.low}–${i?.high} %)`)
};

const de_de2_body_assessment_bodyfat_value = /** @type {(inputs: Body_Assessment_Bodyfat_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`etwa ${i?.percent} % (Spanne ${i?.low}–${i?.high} %)`)
};

const it_it2_body_assessment_bodyfat_value = /** @type {(inputs: Body_Assessment_Bodyfat_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`circa ${i?.percent}% (intervallo ${i?.low}–${i?.high}%)`)
};

/**
* | output |
* | --- |
* | "about {percent}% (range {low}–{high}%)" |
*
* @param {Body_Assessment_Bodyfat_ValueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_bodyfat_value = /** @type {((inputs: Body_Assessment_Bodyfat_ValueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Bodyfat_ValueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_bodyfat_value(inputs)
	if (locale === "es-419") return es_419_body_assessment_bodyfat_value(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_bodyfat_value(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_bodyfat_value(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_bodyfat_value(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_bodyfat_value(inputs)
	return en_us2_body_assessment_bodyfat_value(inputs)
});
export { body_assessment_bodyfat_value as "body-assessment.bodyfat_value" }